import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocationDefinition } from '@register/proxy/register-service/locations';
import { LocationTreeNode } from '@/locations/models/location-tree-node.model';

@Component({
  selector: 'app-location-input-picker',
  templateUrl: './location-input-picker.component.html',
  styleUrls: ['./location-input-picker.component.scss'],
})
export class LocationInputPickerComponent {
  @Input() label: string;
  @Input() locationDefinition: LocationDefinition;
  @Input() locationName: string;
  @Input() readonly: boolean = false;
  @Input() required: boolean = false;
  @Output() locationSelected = new EventEmitter<LocationTreeNode>();

  isModalOpen = false;

  openLocationPicker() {
    if (!this.readonly) {
      this.isModalOpen = true;
    }
  }

  onLocationSelected(location: LocationTreeNode | null) {
    this.locationSelected.emit(location);
    this.isModalOpen = false;
  }

  onModalClose() {
    this.isModalOpen = false;
  }
}
